import { WatchlistSelectorStoreModuleFactory } from '../watchlist-selector/index.module.js';
import { WatchlistPositionListStoreModuleFactory } from '../watchlist-position-list/index.module.js';
import { WatchlistPositionAddStoreModuleFactory } from '../watchlist-position-add/index.module.js';
import { WatchlistPositionDeleteStoreModuleFactory } from '../watchlist-position-delete/index.module.js';
import { WatchlistCreateStoreModuleFactory } from '../watchlist-create/index.module.js';
import { WatchlistEditStoreModuleFactory } from '../watchlist-edit/index.module.js';
import { WatchlistDeleteStoreModuleFactory } from '../watchlist-delete/index.module.js';
import { WatchlistListModuleFactory } from '../../endpoints/watchlist/list.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getLanguage, getEndpointOptions, inheritEndpointOptions } from '../../helpers/common.js';

class WatchlistStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultLanguage = "en";
  }
  getWatchlistListRequest(payload) {
    return {};
  }
  getWatchlistListData(payload) {
    var _a;
    const request = this.getWatchlistListRequest(payload);
    const response = this.getEndpoints().watchlistList.getData(request);
    return (_a = response == null ? void 0 : response.data) != null ? _a : null;
  }
  getResponseData(payload) {
    const watchlistListData = this.getWatchlistListData(payload);
    return {
      hasWatchlists: (watchlistListData != null ? watchlistListData : []).length > 0
    };
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload)
    };
  }
  async updateWatchlistList(payload) {
    const request = this.getWatchlistListRequest(payload);
    return this.getEndpoints().watchlistList.updateState(request);
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    this.store.subscribeAction({
      after: async (action) => {
        if (this.isWatchlistPositionAddType(action.type) || this.isWatchlistPositionDeleteType(action.type)) {
          const watchlistId = action.payload.data.id;
          await this.refreshWatchlistPositionListState(payload, watchlistId);
        }
      }
    });
    try {
      await this.updateWatchlistList(payload);
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return Promise.resolve(isResponseSuccessful);
  }
  isWatchlistPositionAddType(actionType) {
    return actionType === `${this.getDependencies().watchlistPositionAdd.getEndpoints().watchlistPositionCreate.getNameSpace()}/fetchEndpointData`;
  }
  isWatchlistPositionDeleteType(actionType) {
    return actionType === `${this.getDependencies().watchlistPositionDelete.getEndpoints().watchlistPositionDeleteModule.getNameSpace()}/fetchEndpointData`;
  }
  getWatchlistPositionListRequest(id, payloadLanguage) {
    return { id, language: getLanguage(payloadLanguage, this.defaultLanguage, this.options), sort: null, itemsPerPage: 10, pageOffset: 0 };
  }
  async refreshWatchlistPositionListState(payload, watchlistId) {
    try {
      const request = this.getWatchlistPositionListRequest(watchlistId, payload.language);
      return this.getDependencies().watchlistPositionList.refreshState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a;
    if (!this.endpoints) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      this.endpoints = {
        watchlistList: this.getModuleEntity(WatchlistListModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistList"))
      };
    }
    return this.endpoints;
  }
  getDependencies() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!this.dependencies) {
      const endpointConfiguration = (_a = this.options) == null ? void 0 : _a.endpointConfiguration;
      const factoryData = {
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store
      };
      this.dependencies = {
        watchlistSelector: new WatchlistSelectorStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_b = this.options) == null ? void 0 : _b.selector)
        }),
        watchlistPositionList: new WatchlistPositionListStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_c = this.options) == null ? void 0 : _c.positionList)
        }),
        watchlistPositionAdd: new WatchlistPositionAddStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_d = this.options) == null ? void 0 : _d.positionAdd)
        }),
        watchlistPositionDelete: new WatchlistPositionDeleteStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_e = this.options) == null ? void 0 : _e.positionDelete)
        }),
        watchlistCreate: new WatchlistCreateStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_f = this.options) == null ? void 0 : _f.create)
        }),
        watchlistEdit: new WatchlistEditStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_g = this.options) == null ? void 0 : _g.edit)
        }),
        watchlistDelete: new WatchlistDeleteStoreModuleFactory({
          ...factoryData,
          options: inheritEndpointOptions(endpointConfiguration, (_h = this.options) == null ? void 0 : _h.delete)
        })
      };
    }
    return this.dependencies;
  }
}

export { WatchlistStoreModuleFactory };
